import { DEFAULT_ORIENTATION, PAGE_SIZES_MAP, DEFAULT_SIZE } from "report/Constants";
const usePaperDimensions = (pageSize, orientation = DEFAULT_ORIENTATION) => {
  const {
    portraitDimensions: { height, width },
    previewLayoutMultiplier
  } = PAGE_SIZES_MAP[pageSize != null ? pageSize : DEFAULT_SIZE];
  const layoutMultiplier = previewLayoutMultiplier[orientation];
  return orientation === "landscape" ? { width: height * layoutMultiplier, height: width * layoutMultiplier } : { height: height * layoutMultiplier, width: width * layoutMultiplier };
};
export default usePaperDimensions;
